import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    id: "fill-sidebar-gap",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    })
  }, null, 2), _createElementVNode("div", {
    id: "mask",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    }),
    onClick: _cache[0] || (_cache[0] = $event => $setup.sidebar.mutations.switchSidebarClose(false))
  }, null, 2), _createElementVNode("div", {
    id: "sidebar-content",
    class: _normalizeClass({
      'open': !$setup.sidebar.states.isSidebarClose
    })
  }, [_createVNode(_component_el_menu, {
    "default-active": $setup.state.activeLink,
    class: "el-menu-vertical-demo",
    collapse: $setup.sidebar.states.isSidebarClose,
    "collapse-transition": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
      index: "home",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.HOME'),
      onClick: _cache[1] || (_cache[1] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-home');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#home"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("SIDEBAR.HOME")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "library",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.LIBRARY'),
      onClick: _cache[2] || (_cache[2] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-library');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#library"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("SIDEBAR.LIBRARY")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "skill-paths",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.SKILL_PATH'),
      onClick: _cache[3] || (_cache[3] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-skill-path');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#skill-path"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("SIDEBAR.SKILL_PATH")), 1)) : _createCommentVNode("", true), _cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "label",
        style: {}
      }, "New", -1))]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "master-class",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.MASTER_CLASS'),
      onClick: _cache[4] || (_cache[4] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-masterclass');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#master-class"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("SIDEBAR.MASTER_CLASS")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "webinar",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.WEBINAR'),
      onClick: _cache[5] || (_cache[5] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-webinar');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#webinar"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("SIDEBAR.WEBINAR")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _cache[21] || (_cache[21] = _createElementVNode("div", {
      class: "rl-row-10"
    }, [_createElementVNode("div", {
      class: "divide-line"
    })], -1)), _createVNode(_component_el_menu_item, {
      index: "bookmark",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.BOOKMARK'),
      onClick: _cache[6] || (_cache[6] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-bookmark');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#bookmark_1_"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("SIDEBAR.BOOKMARK")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      index: "history",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.HISTORY'),
      onClick: _cache[7] || (_cache[7] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-history');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#history"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("SIDEBAR.HISTORY")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _cache[22] || (_cache[22] = _createElementVNode("div", {
      class: "rl-row-10"
    }, [_createElementVNode("div", {
      class: "divide-line"
    })], -1)), _createVNode(_component_el_menu_item, {
      index: "online-manual",
      class: "tooltip",
      "data-content": _ctx.$t('SIDEBAR.ONLINE_MANUAL'),
      onClick: _cache[8] || (_cache[8] = $event => {
        $setup.closeSidebar();
        $setup.gaTrackButtonClick('leftmenu-online-manual');
        $setup.routerPush($event);
      })
    }, {
      default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("div", null, [_createElementVNode("svg", {
        viewBox: "0 0 34 34",
        class: "sidebar-logo"
      }, [_createElementVNode("use", {
        "xlink:href": "#manual"
      })])], -1)), !$setup.sidebar.states.isSidebarClose ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("SIDEBAR.ONLINE_MANUAL")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["data-content"]), _createVNode(_component_el_menu_item, {
      class: "center-rl-logo"
    }, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: 'https://www.reallusion.com' + $setup.currentLangPath,
        target: "_blank",
        onClick: _cache[9] || (_cache[9] = $event => $setup.gaTrackButtonClick('leftmenu-rl-logo'))
      }, [(_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 500 49.987",
        class: "rl-logo-l",
        style: _normalizeStyle({
          'display': $setup.sidebar.states.isSidebarClose ? 'none' : 'block'
        })
      }, _cache[19] || (_cache[19] = [_createElementVNode("use", {
        "xlink:href": "#rl-logo-l"
      }, null, -1)]), 4)), (_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 34 34",
        class: "rl-logo-s",
        style: _normalizeStyle({
          'display': !$setup.sidebar.states.isSidebarClose ? 'none' : 'block'
        })
      }, _cache[20] || (_cache[20] = [_createElementVNode("use", {
        "xlink:href": "#rl-logo-s"
      }, null, -1)]), 4))], 8, _hoisted_9)]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "collapse"])], 2)], 64);
}